export function LoadingSkeleton() {
  return (
    <div className="space-y-4 animate-pulse">
      <div className="bg-white rounded-xl border border-slate-200 p-5">
        <div className="h-1 bg-gradient-to-r from-slate-200 to-slate-100 rounded mb-4" />
        <div className="flex justify-between">
          <div className="space-y-2">
            <div className="h-6 w-40 animate-shimmer rounded" />
            <div className="h-4 w-56 animate-shimmer rounded" />
          </div>
          <div className="space-y-2 text-right">
            <div className="h-3 w-24 animate-shimmer rounded ml-auto" />
            <div className="h-3 w-32 animate-shimmer rounded ml-auto" />
          </div>
        </div>
      </div>

      {[1, 2].map((i) => (
        <div key={i} className="bg-white rounded-xl border border-slate-200 p-5">
          <div className="flex justify-between mb-4">
            <div className="space-y-2">
              <div className="h-5 w-20 animate-shimmer rounded" />
              <div className="h-4 w-64 animate-shimmer rounded" />
            </div>
            <div className="h-4 w-24 animate-shimmer rounded" />
          </div>
          <div className="h-1.5 w-full animate-shimmer rounded-full mb-4" />
          <div className="space-y-4 pl-2">
            {[1, 2, 3, 4, 5].map((j) => (
              <div key={j} className="flex items-center gap-3">
                <div className="w-7 h-7 rounded-full animate-shimmer shrink-0" />
                <div
                  className="h-4 animate-shimmer rounded"
                  style={{ width: `${60 + ((j * 31) % 80)}px` }}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
